<ng-container *transloco="let t">
  <section class="content-subsidiaries">
    <div class="ui-title">
      {{ t('subsidiaries.sectionTitle') }}

      <pxw-input-switch
        name="orderByNearest"
        [legend]="t('subsidiaries.orderByNearest')"
        [ngModel]="orderBy() === 'nearest'"
        (ngModelChange)="$event ? onOrderByNearest() : onOrderByCity()"
      />
    </div>
    @if (!loading()) {
      @if (orderBy() === 'city') {
        <div
          #scrollTarget
          class="subsidiaries-wrapper"
          [ngClass]="{ 'with-headings': displayCitiesHeading() }"
        >
          @if (isBrowser && displayCitiesHeading()) {
            <pxw-sticky-heading
              [scrollTarget]="scrollTarget"
              [targetElements]="linkedStickyHeadings()"
            ></pxw-sticky-heading>
          }
          @for (group of subsidiariesByCity(); track group) {
            @if (displayCitiesHeading()) {
              <h2 class="group-heading" #cityHeading>
                <span class="title">
                  <pxw-icon icon="building" color="blue" size="sm"></pxw-icon>
                  @if (group.subsidiaries.length > 1) {
                    {{ group.city }}
                  } @else {
                    {{ group.subsidiaries[0].addressDetails?.state || group.city }}
                  }
                </span>
              </h2>
            }
            <div class="grid-subsidiaries">
              @for (subsidiary of group.subsidiaries; track subsidiary) {
                <app-subsidiary [subsidiary]="subsidiary"></app-subsidiary>
              }
            </div>
          }
        </div>
      } @else {
        <div class="subsidiaries-wrapper">
          <div class="grid-subsidiaries">
            @for (subsidiary of nearestSubsidiaries(); track subsidiary) {
              <app-subsidiary
                [subsidiary]="subsidiary"
                [distance]="subsidiariesDistances()[subsidiary.slug]"
              ></app-subsidiary>
            }
          </div>
        </div>
      }
    } @else {
      <div class="ui-loader">
        <pxw-icon icon="loading" [spin]="true"></pxw-icon>
      </div>
    }
  </section>
</ng-container>
